import { c as _c } from "react/compiler-runtime";
import { adsOnlineLinkClick } from './tracking';
import { PrivateUserAdsOnlineCounterProps } from './types';
export const PrivateUserAdsOnlineCounter = t0 => {
  const $ = _c(19);
  const {
    item,
    numberOfAdsOnline,
    linkToUserProfile: t1,
    buttonClassName,
    labelClassName,
    counterClassName
  } = t0;
  const linkToUserProfile = t1 === undefined ? false : t1;
  if (!numberOfAdsOnline) {
    return;
  }
  let t2;
  if ($[0] !== counterClassName || $[1] !== numberOfAdsOnline) {
    t2 = <span className={counterClassName}>{numberOfAdsOnline}</span>;
    $[0] = counterClassName;
    $[1] = numberOfAdsOnline;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = numberOfAdsOnline === 1 ? "Annuncio online" : "Annunci online";
  let t4;
  if ($[3] !== labelClassName || $[4] !== t3) {
    t4 = <p className={labelClassName}>{t3}</p>;
    $[3] = labelClassName;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[6] = t2;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  const content = t5;
  if (linkToUserProfile && item?.advertiser?.userId) {
    const t6 = `/utente/${item.advertiser.userId}`;
    let t7;
    if ($[9] !== item) {
      t7 = () => adsOnlineLinkClick(item);
      $[9] = item;
      $[10] = t7;
    } else {
      t7 = $[10];
    }
    let t8;
    if ($[11] !== buttonClassName || $[12] !== content || $[13] !== t6 || $[14] !== t7) {
      t8 = <a className={buttonClassName} href={t6} onClick={t7} data-e2e="private-user-ads-online">{content}</a>;
      $[11] = buttonClassName;
      $[12] = content;
      $[13] = t6;
      $[14] = t7;
      $[15] = t8;
    } else {
      t8 = $[15];
    }
    return t8;
  }
  let t6;
  if ($[16] !== buttonClassName || $[17] !== content) {
    t6 = <div className={buttonClassName}>{content}</div>;
    $[16] = buttonClassName;
    $[17] = content;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  return t6;
};